// extracted by mini-css-extract-plugin
export var actions = "_r7-4";
export var item = "_r7-1";
export var price = "_r7-3";
export var quantity = "_r7-2";
export var table = "_r7-0";